// ENUMS
export enum ModuleAction {
    View = "view"
}

export enum ExamAction {
    Start = "start",
    Submit = "submit",
    Result = "result"
}

export enum QuestionAction {
    Answer = "answer",
    Skip = "skip"
}

// EVENT PROPERTIES

export interface ModuleProperties {
    id: string, //module id
    action: ModuleAction,
    progress: number
}

export interface ExamProperties {
    id: string, // exam id
    action: ExamAction,
    duration?: number,
    score?: number,
    is_passed?: boolean
}

export interface QuestionProperties {
    id: string, // question id
    exam_id: string,
    action: QuestionAction,
    answer_id: string
}